import crypto from "crypto";
import base64 from "base-64";

const Definicao = {
    algoritmo : "aes256",
    codificacao : "utf8",
    segredo : "frontend13072020@cosin$1",
    tipo : "hex"
};

export function trataCpo(cpo, def) {
        var mykey = crypto.createCipher(Definicao.algoritmo, def);
        var mystr = mykey.update(cpo, Definicao.codificacao,  Definicao.tipo)
        mystr += mykey.final( Definicao.tipo);
        return mystr;
};

export function retornaCpo(cpo, def) {
        var mykey = crypto.createDecipher(Definicao.algoritmo, def);
        var mystr = mykey.update(cpo, Definicao.tipo, Definicao.codificacao)
        mystr += mykey.final(Definicao.codificacao);
        return mystr;
};

export function setMemoria(nome,email,tipo){
        if (tipo){
                localStorage.setItem("NomeParticipante", nome);
                localStorage.setItem("Email", trataCpo(email, "ANA-COSIN"));
                if (email.toLowerCase().indexOf("@ana.gov.br") > -1 ){
                        localStorage.setItem("ANA", "S");
                } else {
                        localStorage.setItem("ANA", "N");
                }
        } else {
                localStorage.removeItem("NomeParticipante");
                localStorage.removeItem("Email");
                localStorage.removeItem("idPessoa");
                localStorage.removeItem("ANA");
                localStorage.removeItem("Login");
        }
}
export function retornaEmail(){
        const email = localStorage.getItem("Email");
        let retorno = "";
        if (email){
                retorno = retornaCpo(email,"ANA-COSIN")  
        }
        return retorno;
}
export function retornaParm(){
        let ts = Date.now();
        ts = (Math.floor(ts/1000));
        const parm = `${Definicao.segredo}:${ts}`;
        return base64.encode(parm);
}